var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reddit",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M35-.016a35,35,0,1,0,35,35,35,35,0,0,0-35-35Z",
    transform: "translate(-0.005 0.016)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M21.42,28.448a3.384,3.384,0,0,1-3.629-3.061,3.385,3.385,0,0,1,3.629-3.061,3.384,3.384,0,0,1,3.627,3.061A3.384,3.384,0,0,1,21.42,28.448Zm26.25-2.135a6.712,6.712,0,0,1,.084,1.03c0,6.365-9.023,11.544-20.116,11.544S7.52,33.709,7.52,27.344a6.812,6.812,0,0,1,.09-1.074A4.481,4.481,0,0,1,5.349,22.5c0-2.591,2.491-4.69,5.562-4.693a6.271,6.271,0,0,1,3.317.929,29.523,29.523,0,0,1,12.465-2.924l3.543-8.5L38.726,9.03a4.8,4.8,0,0,1,4.1-2.085c2.562,0,4.639,1.755,4.642,3.918s-2.08,3.915-4.642,3.918c-2.408,0-4.4-1.559-4.621-3.543L31.95,9.975,29.5,15.849a29.086,29.086,0,0,1,11.582,2.91,6.253,6.253,0,0,1,3.35-.951c3.07,0,5.558,2.1,5.561,4.693a4.477,4.477,0,0,1-2.324,3.812ZM8.015,22.5a2.159,2.159,0,0,0,.463,1.316,11.621,11.621,0,0,1,3.373-3.631,3.355,3.355,0,0,0-2.622.327A2.358,2.358,0,0,0,8.015,22.5Zm37.071,4.84c0-5.126-7.829-9.295-17.451-9.295s-17.451,4.17-17.451,9.295,7.829,9.295,17.451,9.295S45.086,32.47,45.086,27.344Zm-1.642-7.137a11.545,11.545,0,0,1,3.38,3.672,2.168,2.168,0,0,0,.509-1.375,2.363,2.363,0,0,0-1.238-2,3.359,3.359,0,0,0-2.651-.3Zm-2.592-9.341a2.023,2.023,0,0,0,3.953,0,2.023,2.023,0,0,0-3.953,0ZM34.333,30.843a1.452,1.452,0,0,0-.942.329c-.071.06-1.815,1.444-5.792,1.444-3.928,0-5.511-1.385-5.515-1.389a1.508,1.508,0,0,0-1.878-.117,1.007,1.007,0,0,0-.138,1.585,6.313,6.313,0,0,0,1.872,1.145,14.321,14.321,0,0,0,5.66,1.023,15.182,15.182,0,0,0,5.729-1.005A7.293,7.293,0,0,0,35.3,32.74a1.307,1.307,0,0,0,1.278-.841,1.06,1.06,0,0,0-.638-1.257,1.513,1.513,0,0,0-1.6.2Zm-.042-8.517a3.385,3.385,0,0,0-3.629,3.061,3.385,3.385,0,0,0,3.629,3.061,3.384,3.384,0,0,0,3.627-3.061A3.384,3.384,0,0,0,34.291,22.325Z",
    transform: "translate(7.339 12.082)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.12322f4b8072a831866937824d4c14f4.svg";
export { ForwardRef as ReactComponent };